(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('ApplicationError', ApplicationError);

    function ApplicationError() {
        var slice = Array.prototype.slice,
            bind = Function.prototype.bind,
            unshift = Array.prototype.unshift;

        function ApplicationError(message, params) {
            if (!(this instanceof ApplicationError)) 
                return new (bind.apply(ApplicationError, unshift.call(arguments, null) && arguments))();

            // Error.call(this, message) <=== not necessary
            params = slice.call(arguments, 1);
            this.name = 'ApplicationError';
            this.message = message.format.apply(message, params);
        }

        ApplicationError.prototype = Object.create(Error.prototype);
        ApplicationError.prototype.constructor = ApplicationError;
        return ApplicationError;
    }
})();